/**
 * Image-tool API — the off-intent post-process layer. Calls create-runtime
 * /api/customer/tools/:tool (fal tool models) + vision/analyze.
 * why → ADR-005 #3 (was the retired images-worker /api/images/* that 404'd).
 */

import { CONFIG } from '../core/config.js'
import { apiRequest } from './index.js'

// POST a tool job; returns { image_url, cost_cents } (url alias kept for callers
// that read res.url). why → ADR-005 #3.
async function runTool(tool, payload) {
  const data = await apiRequest(`${CONFIG.FRONTEND_API}/api/customer/tools/${tool}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  const result = data.data || data || {}
  return { ...result, url: result.image_url || result.url }
}

// Remove background (fal birefnet)
export async function removeBackground(imageUrl) {
  return runTool('remove-bg', { image_url: imageUrl })
}

// Upscale (fal esrgan)
export async function upscaleImage(imageUrl, scale) {
  return runTool('upscale', { image_url: imageUrl, scale })
}

// Smart segment (fal sam2)
export async function smartSegment(imageUrl) {
  return runTool('segment', { image_url: imageUrl })
}

// Vision analysis — returns { asset_id, cards, analysis }.
export async function analyzeImageVision(imageUrl) {
  return apiRequest(`${CONFIG.FRONTEND_API}/api/customer/vision/analyze`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ image_url: imageUrl }),
  })
}

// Tools now return the final image_url directly — there is no separate "save"
// step in the create-runtime contract; the result is persisted as an asset by the
// caller flow. Kept as no-ops so existing callers don't break. why → ADR-005 #3.
export async function saveRemoveBgResult(previewUrl) {
  return { image_url: previewUrl, url: previewUrl }
}
export async function saveUpscaleResult(previewUrl) {
  return { image_url: previewUrl, url: previewUrl }
}

// auto-tag is not a create-runtime tool (vision/analyze produces tags instead).
export async function autoTag() {
  console.warn('[AI Tools] autoTag is superseded by vision/analyze')
  return null
}

// Style-transfer is an edit INTENT (B-class), not a tool — use the create flow.
export async function styleTransfer() {
  console.warn('[AI Tools] styleTransfer is a B-class intent, not a tool')
  return null
}
export async function fetchStylePresets() {
  return []
}
export async function checkStyleTask() {
  return null
}
